jQuery(document).ready(function($){


    /*
    *   This file controls the ajax requests and templating of 3 different 
    *   archive pages on the website. 
    *
    * 
    * */


   //event listeners and initialization on page load. 
   var filter_post_type = $('[data-filter-post-type]').attr('data-filter-post-type');

    if ('post' == filter_post_type){
        filterBlogs();
    }

    if ('courses' == filter_post_type){
        filterCourses();

        setTimeout(function(){ 
            $('.toggled-taxonomy[data-taxonomy="learning-paths"] h2').trigger('click');
        }, 100);


    }

    if ('events' == filter_post_type){
        filterEvents();
    }

    $('.search-button').click(function(){

        if ('post' == filter_post_type){
            filterBlogs();
        }

        if ('courses' == filter_post_type){
            filterCourses();
        }

        if ('events' == filter_post_type){
            filterEvents();
        }
    });

    $(document).keypress(function(event){
	
        var keycode = (event.keyCode ? event.keyCode : event.which);

        if(keycode != '13'){
            return;	
        }

        if ('post' == filter_post_type){
            filterBlogs();
        }

        if ('courses' == filter_post_type){
            filterCourses();
        }

        if ('events' == filter_post_type){
            filterEvents();
        }
    
    });

    $('.taxonomy-container input[type="checkbox"]').on('change', function(){

        if ('post' == filter_post_type){
            filterBlogs();
        }

        if ('courses' == filter_post_type){
            filterCourses();
        }

        if ('events' == filter_post_type){
            filterEvents();
        }

    });

    $('#load-more-button').click(function(){

        var search_val = $('#archive-search').val();

        //subtract 1 since the sidebar does not count as a post.
        var action;
        var offset;
        if (filter_post_type == 'post'){
            offset = ($('.post-holder').length) -1;
            action = 'filter_blog_archives';
        }

        else if (filter_post_type == 'events'){
            offset = ($('.post-holder').length) -1;
            action = 'filter_events';
        }
        else{
            offset = $('.post-holder').length;
        }

        var taxonomies = grabTaxonomies();

        ThemeJS.Functions.send_ajax_request({

            data: {
                action: action,
                search: search_val,
                taxonomies: taxonomies,
                post_type: filter_post_type,
                offset: offset,

                
            },
            success: ( data ) => {


                if (filter_post_type == 'post'){

                    $.each(data.posts, function(index, value){
                        $('.post-container ').append(displayNormalPost(value));
                    });
                }

                else if(filter_post_type == 'events'){

                    $.each(data.events, function(index, value){
                        $('.post-container .events-list').append(displayNormalEvent(value))
                    });

                }
                    

                

                toggleLoadMoreButton(data, filter_post_type);

                matchHeights();

            },
            error: ( data ) => {
            }
        });

    });


    /*----------------------------------------------------------*\
                BLOG ARCHIVE FUNCTIONALITY & TEMPLATES
    \*----------------------------------------------------------*/

    function filterBlogs(){
        showLoader();

        var search_val = $('#archive-search').val();


        var taxonomies = grabTaxonomies();


        ThemeJS.Functions.send_ajax_request({
            
            data: {
                action: 'filter_blog_archives',
                search: search_val,
                taxonomies: taxonomies,

                
            },
            success: ( data ) => {
                hideLoader();
                $('.post-container').html('');
                

                var counter = 1;
                var container_html = "";
                $.each(data.posts, function(index, value){

                    

                     if (counter == 3){
                        container_html+= displaySideBar(data.popular_posts);
                        container_html+= displayNormalPost(value);
                    }

                    else{
                        container_html+= displayNormalPost(value);
                    }

                    counter++;

                });

                $('.post-container').html(container_html);

                toggleLoadMoreButton(data, filter_post_type)

                matchHeights();

            },
            error: ( data ) => {
            }
        });

    }

    function displaySideBar(posts){
        var html =  `
        <div class="col-12 col-md-6  col-lg-6 col-xl-4  popular-posts normal-posts post-holder">
            <div class="post-background">
                <h2>Most Popular</h2>
                <div class="popular-holder"> `;

                $.each(posts, function(index, value){
                    html+= `
                    <div class="popular-post">
                        <div class="popular-post-inner">
                            <span class="taxonomies">${value.tags}</span>
                            <h3><a href="${value.permalink}">${value.post_title}</a></h3>
                        </div>
                        
                    </div>
                    `
                });
                   
        
        html+= `
                </div>
            </div>
        </div>
        `;
        return html;
    }

    function displayBigColumn(post){

        var html = `
        <div class="col-12 post-holder first-post-holder">
            <div class="inner">
                <img class="decorative-left" src="${ThemeJS.Variables.Ajax.decorative_background_post_image_left}" alt="decorative background left">
                <img class="decorative-right" src="${ThemeJS.Variables.Ajax.decorative_background_post_image_right}" alt="decorative background right">

                <div class="post-background">
                    <div class="row">
                        <div class="col-12 col-md-7 order-3 order-md-1">
                            <div class="post-copy">
                                <div class="title-holder">
                                    <a href="${post.permalink}">
                                    <h2>${post.post_title}</h2>
                                    </a>
                                    <span class="author"> By ${post.author}</span>
                                </div>
                                <p>${post.excerpt}</p>

                                
                                <a class="btn btn-blue" href="${post.permalink}">Read More<span class="sr-only">about ${post.post_title}</span></a>
                                <div class="row mt-4">
                                    <div class="col-6">

                                        <span class="taxonomies">${post.tags}</span>    

                                    </div>
                                    <div class="col-6 text-right">
                                        <span class="date">${post.post_date}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-5 order-2">
                            <div class="img-col">

                                <div class="img-gradient"></div>

                                    ${post.thumbnail}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;
    return html;

    }

    function displayNormalPost(post){
        var html = `
            <div class="col-12 col-md-6 col-lg-6 col-xl-4 normal-posts post-holder">
                <div class="post-background">
                    <div class="post-copy">
                        <div class="before-image">
                            <h2>${post.post_title}</h2>
                            <span class="author d-block mb-2">By ${post.author}</span>
                            <p>${post.excerpt}<a href="${post.permalink}" class="read-more-link fas fa-chevron-double-right"><span class="sr-only">Read about ${post.post_title}</span></a></p>
                        </div>
                        
                        <div class="img-container my-2">
                            
                            ${post.thumbnail}

                        </div>
                        <div class="row">
                            <div class="col-6">

                                <span class="taxonomies">${post.tags}</span>

                            </div>
                            <div class="col-6 text-right">
                                <span class="date">${post.post_date}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
        return html;

    }

     /*----------------------------------------------------------*\
                EVENT ARCHIVE FUNCTIONALITY & TEMPLATES
    \*----------------------------------------------------------*/

    function filterEvents(){
        showLoader();

        var search_val = $('#archive-search').val();

        var taxonomies = grabTaxonomies();

        ThemeJS.Functions.send_ajax_request({
                
            data: {
                action: 'filter_events',
                search: search_val,
                taxonomies: taxonomies,
            },
            success: ( data ) => {
                hideLoader();
                $('.post-container .no-results').text('');
                $('.post-container .events-list').html('');


                if (data.total_posts === 0){
                    $('.post-container .no-results').text('Sorry, no results found.');
                    return;
                }
                

                var container_html = "";
                var counter  = 1;
                $.each(data.events, function(index, event){

                    if (counter === 1){
                        container_html+= displayBigEvent(event);
                    }

                    else if (counter === 4){
                        container_html+= displayEventSideBar(data.past_events);
                        container_html+= displayNormalEvent(event);
                    }

                    else{
                        container_html+= displayNormalEvent(event);
                    }


                    counter++;
                });

                $('.post-container .events-list').html(container_html);

                toggleLoadMoreButton(data, filter_post_type)


                matchHeights();
            },
            error: ( data ) => {
                console.log(data);
            }
        });
    }

        function displayBigEvent(event){
            
            var html = `
                <div class="col-12 post-holder first-post-holder">
                    <img class="decorative-left" src="${ThemeJS.Variables.Ajax.decorative_background_post_image_left}" alt="decorative background left">
                    <img class="decorative-right" src="${ThemeJS.Variables.Ajax.decorative_background_post_image_right}" alt="decorative background right">

                    <div class="post-background">
                        <div class="row">
                            <div class="col-12 col-md-7 order-3 order-md-1">
                                <div class="post-copy">
                                    <div class="row">
                                        <div class="col-auto">
                                            <div class="event-date">
                                                <span class="month">${event.start_month}</span>
                                                <span class="day">${event.start_day}</span>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <div class="title-holder">
                                                <h2>${event.post_title}</h2><span class="author d-inline-block"> <span class="fas fa-microphone icon mx-2"></span> ${event.instructor}</span>
                                            </div>
                                        </div>
                                        <div class="col-auto text-right">
                                           <span class="price">${event.price}</span>
                                        </div>
                                    </div>
                                    <div class="d-inline-block date mr-3">
                                    
                                        <span class="fas fa-clock icon mr-2"></span>
                                        <span>${event.start_time} - ${event.end_time}</span>

                                    </div>
                                    <div class="d-inline-block location">
                                        <span class="fas fa-map-marker-alt mr-2 icon"></span>
                                        <span>${event.location}</span>
                                    </div>
                                    
                                    
                                    <p class="mt-2">${event.excerpt}</p>

                                    
                                    <a class="btn btn-blue" href="${event.permalink}">Read More<span class="sr-only">about ${event.post_title}</span></a>
                                    <div class="row mt-4">
                                        <div class="col-6">

                                            <span class="taxonomies">${event.tags}</span>    

                                        </div>
                                        <div class="col-6 text-right">
                                            <span class="date"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-5 order-2">
                                <div class="img-col">

                                    <div class="img-gradient"></div>

                                        ${event.thumbnail}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            `;
            
            return html;
        }  
        
        function displayEventSideBar(events){
            var html =  `
                <div class="col-12 col-lg-6 col-xl-4  popular-posts normal-posts post-holder">
                    <div class="post-background">
                        <h2>Past Events</h2>
                        <div class="popular-holder"> `;

                        $.each(events, function(index, event){
                            html+= `
                            <div class="popular-post">
                                <div class="popular-post-inner">
                                    <span class="taxonomies">${event.tags}</span>
                                    <h3><a href="${event.permalink}">${event.post_title}</a></h3>
                                </div>
                                
                            </div>
                           `
                        });
                        
                
                html+= `
                        </div>
                    </div>
                </div>
                `;

            return html;
        }

        function displayNormalEvent(event){
            
            var html = `
                <div class="col-12 col-lg-6 col-xl-4 normal-posts post-holder">
                    <div class="post-background">
                        <div class="post-copy">
                            <div class="row">
                                <div class="col-auto">
                                    <div class="event-date">
                                        <span class="month">${event.start_month}</span>
                                        <span class="day">${event.start_day}</span>
                                    </div>
                                </div>
                                <div class="col">
                                     <h2 class="d-inline-block">${event.post_title} 
                                     <span class="price d-inline-block">${event.price}</span>
                                     </h2>
                                </div>
                            </div>
                            <div class="row event-meta my-3">
                                <div class="col-auto">
                                <span class="fa-fw fas fa-microphone icon mr-2 icon"></span>
                                 <span class="instructor">${event.instructor}</span>
                                </div>
                                <div class="col-auto">
                                    <span class="fa-fw fas fa-clock icon mr-2 icon"></span>
                                    <span class="date">${event.start_time} - ${event.end_time}</span>
                                </div>
                                <div class="col-12">
                                    <span class="fa-fw fas fa-map-marker-alt mr-2 icon"></span>
                                    <span class="location">${event.location}</span>
                                </div>
                                <a href="${event.permalink}" class="read-more-link fas fa-chevron-double-right"><span class="sr-only">Read about ${event.post_title}</span></a>

                            </div>
                           
                            <div class="img-container my-1">
                                
                                ${event.thumbnail}

                            </div>
                            <div class="row">
                                <div class="col-12">

                                    <span class="taxonomies">${event.tags}</span>

                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            `;
            return html;

        }



     /*----------------------------------------------------------*\
                COURSES ARCHIVE FUNCTIONALITY & TEMPLATES
    \*----------------------------------------------------------*/

        function filterCourses(){
            showLoader();

            var search_val = $('#archive-search').val();


            var taxonomies = grabTaxonomies();


            ThemeJS.Functions.send_ajax_request({
                
                data: {
                    action: 'filter_courses',
                    search: search_val,
                    taxonomies: taxonomies,
                },
                success: ( data ) => {
                    console.log(data);
                    hideLoader();
                    $('.post-container .no-results').text('');
                    $('.post-container ul').html('');

                    if (data.courses === undefined){
                        $('.post-container .no-results').text('Sorry, no results found.');
                        return;
                    }
                    

                    var container_html = "";
                    $.each(data.courses, function(index, value){

                        container_html+= displayCourseSession(value);

                    });

                    $('.post-container ul').html(container_html);

                    toggleLoadMoreButton(data, filter_post_type)


                    matchHeights();
                },
                error: ( data ) => {

                }
            });
        }

        function displayCourseSession(course){
            var batch_html
            if (course.batch_number){
                batch_html = `<span class="batch">Batch ${course.batch_number}</span>`;
            }
            else{
                batch_html = ``;
            }

            var price_html;
            if (course.price == ""){
                price_html = '<span class="price">Free</span>';
            }
            else{
                price_html = `<span class="price">`;

                if (course.old_price){
                    price_html += `<span class="old-price">$${course.old_price}</span>`;
                }

                price_html += `$${course.price}</span>`;
            }
            

            if (course.days_of_the_week.length){
                course.days_of_the_week = course.days_of_the_week.join(',');
                course.days_of_the_week = course.days_of_the_week.replace('THURS', 'THU');
            }

            var coupon_expiry_html = '';
            if (course.coupon_expiry){
                coupon_expiry_html = `<span class="d-block coupon_deadline">Discount Expiry: ${course.coupon_expiry}</span>`;
            }

            var html = `
                <li class="course-session">
                    <div class="course-session-row row">
                        <div class="col-12 col-lg-auto  col-date text-center d-block d-lg-flex">
                            <div class="align-self-center">
                                <time class="d-inline-block start">
                                    <span class="d-block month">${course.start_month}</span>
                                    <span class="d-block day">${course.start_day}</span>
                                </time>
                                <time class="d-inline-block end">
                                    <span class="d-block month">${course.end_month}</span>
                                    <span class="d-block day">${course.end_day}</span>
                                </time>
                            </div>
                        </div>
                        <div class="col-12 col-lg col-info">
                            <div class="row">
                                <div class="col-12 col-md-6 text-center text-md-left">
                                    <h3 class="d-inline-block mr-2">${course.associated_course_title}</h3>
                                    
                                    ${batch_html}
                
                                    <p><span class="sessions">${course.number_sessions} Sessions</span>   ${course.days_of_the_week}</p>
                                    <a href="${course.permalink}" class="permalink">Read More...<span class="sr-only">about ${course.associated_course_title}</span></a>
                                    <p class="row">
                                        <span class="time col-12 col-md-auto ">
                                            <span class="fas fa-clock icon"></span><span>${course.start_time} - ${course.end_time}</span>
                                        </span>
                                        <span class="location col-12 col-md-auto">
                                            <span class="fas fa-map-marker-alt icon "></span><span>${course.location}</span>
                                        </span>
                                    </p>
                                </div>
                                <div class="col-12 col-md-6 text-center col-info-right-column text-md-right d-flex flex-column justify-content-between">
                                    <div>

                                        ${price_html}
                    
                                        <button data-product-id="${course.ID}" class="btn-blue custom-add-to-cart-button">Apply now</button>
                                    
                                    </div>
                
                                    <p class="deadline mt-2">
                                        ${coupon_expiry_html}
                                        <span>Application Deadline: ${course.registration_deadline}</span> 
                                    </p>

                                </div>
                            </div>                
                        </div>
                    </div>
                </li>
            `
            return html;
        }


    /*----------------------------------------------------------*\
                        GLOBAL FUNCTIONS
    \*----------------------------------------------------------*/

    $(window).resize(function(){

        if (window.matchMedia("(min-width: 1200px)").matches) {
            $('.archive-sidebar').show();

        }

        else{

            if ($('.archive-sidebar').is(':visible')){
                $('.toggle-filters').removeClass('fa-plus-circle');
                $('.toggle-filters').addClass('fa-minus-circle');
            }

            else{
                $('.toggle-filters').addClass('fa-plus-circle');
                $('.toggle-filters').removeClass('fa-minus-circle');
            }
            
        }

    });
    

    $('.show-filters').click(function(){
        $(this).siblings('.archive-sidebar').slideToggle();

        var icon = $(this).find('.toggle-filters');
        if (icon.hasClass('fa-plus-circle')){
            $(icon).removeClass('fa-plus-circle');
            $(icon).addClass('fa-minus-circle');
        }
        else{
            $(icon).addClass('fa-plus-circle');
            $(icon).removeClass('fa-minus-circle');
        }
    });

    $('.toggled-taxonomy h2').click(function(){
        console.log('tst');
        $(this).closest('.toggled-taxonomy').find('.checkbox-holder').slideToggle();

        var caret_icon = $(this).closest('.toggled-taxonomy').find('.toggle-icon')

        if (caret_icon.hasClass('fa-caret-down')){
            caret_icon.removeClass('fa-caret-down');
            caret_icon.addClass('fa-caret-up');

        }

        //hiding the taxonomy, so remove any checked boxes.
        else{
            caret_icon.removeClass('fa-caret-up');
            caret_icon.addClass('fa-caret-down'); 

            var checkboxes = $(this).closest('.toggled-taxonomy').find('.checkbox-container input[type="checkbox"]:checked');
            
            if (checkboxes.length > 0){

                $.each(checkboxes, function(index, value){
                    $(this).prop('checked', false);
                    filterCourses();
                });
            }

        }
    })


    function showLoader(){
        $('.loading-container').show();
        $('.post-container').hide();
        $('.load-more-container').hide();
    }
    
    function hideLoader(){
        $('.loading-container').hide();
        $('.post-container').show();


    }

    function matchHeights(){
        if ($('.post-holder').length > 0){

            $('.normal-posts .post-background').matchHeight();
            // $('.normal-posts .post-background .post-copy h2').matchHeight();
            // $('.normal-posts .post-background .post-copy p').matchHeight();
            // $('.before-image').matchHeight();
    
        }
    }

    function grabTaxonomies(){
        var taxonomies = {};
        $('.taxonomy-container').each(function(index, value){
            var taxonomy = $(this).data('taxonomy');

            var selected_taxonomies = $(this).find('.checkbox-container input[type="checkbox"]:checked');
            var selected_taxonomies_array = [];

            $.each(selected_taxonomies, function(indev, value){
                selected_taxonomies_array.push($(this).val());
            });

            taxonomies[taxonomy] = selected_taxonomies_array;

        });

        return taxonomies;


    }

    function toggleLoadMoreButton(data, filter_post_type){


        if (filter_post_type == 'post' || filter_post_type == 'events'){

            if ((data.total_posts > ($('.post-holder').length -1) && $('.post-holder').length > 3)){
                $('.load-more-container').show();
            }
            else{
                $('.load-more-container').hide();
            }

        }

        

        

    }

});